/**
 * GlobalStyle is now a no-op component.
 *
 * All global styles (fonts, CSS variables, resets) have been moved to
 * src/styles/global.css which is imported in gatsby-browser.js.
 *
 * This shell is kept so existing `import { GlobalStyle } from '@styles'`
 * references don't break during the migration.
 */
const GlobalStyle = () => null;

export default GlobalStyle;
